import { useQuery } from 'react-query';
import useStore from '../../../store';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';

interface IInternationalCombinedData {
  limits: {
    singleLimit: number,
    dailyLimit: number,
    'monthlyLimit': number,
    'balance': number,
  }
  'eddRequired': boolean,
  'eddVersion': string,
  'introRequired': boolean,
  purposes: string[],
    'fees': [
      {
        'arrivalDate': string,
        'arrivalDateShort': string,
        'fee': number
      }
    ]

}

export const getInternationalCombinedData = () => {
  const { customerId } = useStore((state) => state.currUser());
  const { accountExternalId } = useStore((state) => state.getPersonalAccount());

  return useQuery(
    'getInternationalCombinedData',
    async () => {
      const { data } = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/international/wire/out/init`);
      return data as IInternationalCombinedData;
    },
    { enabled: false },
  );
};
